<template>
  <vue-seamless-scroll :v-bind="$attrs" :data="data2" :class-option="classOption2" class="seamless-scroll">
    <ul>
      <li class="list-item" v-for="item in data2" :key="item.id">
        <span style="display: inline-block;" :style="'width:' + item2.width + 'px;'" v-for="item2 in columns2" :key="item2.prop">{{item[item2.prop]}}  </span>
      </li>
    </ul>
  </vue-seamless-scroll>
</template>

<script type="text/ecmascript-6">
import VueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'UniScrollList',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    classOption: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      data2: [],
      columns2: [],
      classOption2: {}
    }
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.data2 = newValue
        }
      },
      deep: true
    },
    columns: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.columns2 = newValue
        }
      },
      deep: true
    },
    classOption: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.classOption2 = newValue
        }
      },
      deep: true
    }
  },
  components: {
    VueSeamlessScroll
  },
  mounted: function () {
    this.data2 = this.data
    this.columns2 = this.columns
    this.classOption2 = this.classOption
  }
}
</script>

<style lang="scss">
  .seamless-scroll {
    overflow: hidden;

    .list-item {
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/uniWidgets/uniScrollList/UniScrollList.vue